import { Routes } from '@angular/router';
import { LoginComponent } from './features/auth/login.component';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { DashboardComponent } from './features/dashboard/dashboard.component';
import { ClientsComponent } from './features/clients/clients.component';
import { PricesComponent } from './features/prices/prices.component';
import { DailyEntryComponent } from './features/daily-entry/daily-entry.component';
import { ReportsComponent } from './features/reports/reports.component';
import { UsersComponent } from './features/users/users.component';
import { SuppliersComponent } from './features/suppliers/suppliers.component';
import { SupplierDetailComponent } from './features/suppliers/supplier-detail.component';
import { PayablesComponent } from './features/payables/payables.component';
import { PaymentsComponent } from './features/payments/payments.component';
import { ImportComponent } from './features/import/import.component';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  { path: 'auth', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', component: DashboardComponent },

      // Suppliers module (Dobavljači)
      { path: 'suppliers', component: SuppliersComponent },
      { path: 'suppliers/:id', component: SupplierDetailComponent },
      { path: 'payables', component: PayablesComponent, canActivate: [adminGuard] },
      { path: 'payments', component: PaymentsComponent, canActivate: [adminGuard] },
      { path: 'import', component: ImportComponent, canActivate: [adminGuard] },

      // Promet (existing meal tracking)
      { path: 'clients', component: ClientsComponent, canActivate: [adminGuard] },
      { path: 'prices', component: PricesComponent, canActivate: [adminGuard] },
      { path: 'daily-entry', component: DailyEntryComponent, canActivate: [adminGuard] },
      { path: 'reports', component: ReportsComponent },
      {
        path: 'control',
        loadComponent: () => import('./features/control/control.component').then(m => m.ControlComponent)
      },

      // Admin
      { path: 'users', component: UsersComponent, canActivate: [adminGuard] },
    ]
  },
  { path: '**', redirectTo: '' }
];
